import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", {
  class: "hidden sm:inline-block sm:align-middle sm:h-screen",
  "aria-hidden": "true"
}, "​", -1)
const _hoisted_3 = { class: "inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-2xl sm:w-full sm:p-6" }
const _hoisted_4 = { class: "mt-2 text-center sm:mt-5" }
const _hoisted_5 = { class: "flex justify-between" }
const _hoisted_6 = { class: "w-1/2 mr-2" }
const _hoisted_7 = {
  for: "originalValue",
  class: "text-left block"
}
const _hoisted_8 = { class: "w-1/2 ml-2" }
const _hoisted_9 = {
  for: "updatedValue",
  class: "text-left block"
}
const _hoisted_10 = { class: "mt-2 pb-2 text-left" }
const _hoisted_11 = {
  for: "notesValue",
  class: "text-left block"
}
const _hoisted_12 = { class: "mt-5 sm:mt-6 text-center" }

import { computed, inject, onMounted, ref, watch } from "vue";
import {
  Dialog,
  DialogTitle,
  DialogOverlay,
  TransitionRoot,
  TransitionChild
} from "@headlessui/vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserActivityLogsDetailDialog',
  props: { form: Object, show: Boolean },
  emits: ["submit", "update:show", "update:form", "filter"],
  setup(__props, { emit }) {

const props = __props





const originalValue = ref();
const updatedValue = ref();
const notesValue = ref();

const showSync = computed({
  get: () => props.show,
  set: (value) => emit("update:show", value),
});

const jsonPrettify = (json: any) => {
  if (typeof json === 'object' && json !== null) {
    const pretty = JSON.stringify(json, undefined, 4);
    return pretty;
  }

  try {
    const obj = JSON.parse(json);
    return jsonPrettify(obj);
  } catch (e) {
    return json;
  }
};

const onClose = () => {
  showSync.value = false;
};

watch(showSync, (val) => {
  if (val) {
    originalValue.value = jsonPrettify(props.form?.originalValue);
    updatedValue.value = jsonPrettify(props.form?.updatedValue);
    notesValue.value = jsonPrettify(props.form?.notes);
  }
});



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(TransitionRoot), {
      as: "template",
      show: _unref(showSync),
      static: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Dialog), {
          as: "div",
          static: "",
          class: "fixed z-10 inset-0 overflow-y-auto",
          onClose: _cache[4] || (_cache[4] = ($event: any) => (showSync.value = false)),
          open: _unref(showSync)
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0",
                "enter-to": "opacity-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100",
                "leave-to": "opacity-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DialogOverlay), { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" })
                ]),
                _: 1
              }),
              _hoisted_2,
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(_unref(DialogTitle), {
                          as: "h3",
                          class: "text-lg leading-6 font-medium text-gray-900 mb-4"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("messages.activityLog.viewDetail")), 1)
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", _hoisted_5, [
                          _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t("messages.activityLog.originalValue")), 1),
                            _withDirectives(_createElementVNode("textarea", {
                              class: "w-full h-72 rounded-md",
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((originalValue).value = $event)),
                              label: "Original Value",
                              name: "originalValue",
                              disabled: ""
                            }, null, 512), [
                              [_vModelText, originalValue.value]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t("messages.activityLog.updatedValue")), 1),
                            _withDirectives(_createElementVNode("textarea", {
                              class: "w-full h-72 rounded-md",
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((updatedValue).value = $event)),
                              label: "Updated Value",
                              name: "updatedValue",
                              disabled: ""
                            }, null, 512), [
                              [_vModelText, updatedValue.value]
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t("messages.activityLog.notes")), 1),
                          _withDirectives(_createElementVNode("textarea", {
                            class: "w-full h-auto rounded-md",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((notesValue).value = $event)),
                            label: "Notes Value",
                            name: "notesValue",
                            disabled: ""
                          }, null, 512), [
                            [_vModelText, notesValue.value]
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (onClose())),
                        class: "mt-3 mr-2 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:col-start-1 sm:text-sm"
                      }, " close ")
                    ])
                  ])
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["open"])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})